import * as React from "react";
import { Select, Spinner } from "components/common";
import useEventDefinitions from "components/event-definitions/hooks/useEventDefinitions";
const EventDefinitionFilter = ({ value, onSelect, selectedValues }) => {
  const { data: eventDefinitions, isInitialLoading: isLoadingEventDefinitions } = useEventDefinitions({
    query: "",
    page: 1,
    pageSize: 1e5,
    sort: { attributeId: "title", direction: "asc" }
  });
  const eventDefinitionOptions = eventDefinitions == null ? void 0 : eventDefinitions.list.map(({ title, id }) => ({
    label: title,
    value: id,
    disabled: selectedValues.includes(id)
  }));
  if (isLoadingEventDefinitions) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: "Select event definition",
      clearable: false,
      menuIsOpen: true,
      options: eventDefinitionOptions,
      onChange: onSelect,
      value
    }
  );
};
export default EventDefinitionFilter;
